import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'components/dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import FileDownloadOutlinedIcon from 'components/material-symbol/icons/FileDownload'
import { useDialogTitleStyles } from 'components/dialog/use-dialog-title-styles'

const DownloadReceiptDialog = ({
  open,
  onClose,
  onDownload,
  isDownloading,
  transactionId,
}) => {
  const classes = useDialogTitleStyles()

  return (
    <Dialog
      isOpen={open}
      onClose={onClose}
      disableClose={isDownloading}
      maxWidth="xs"
      fullWidth
      showCloseButton
      classes={{ paper: classes.dialogPaper }}
    >
      {({ closeDialog }) => (
        <>
          <DialogTitle disableTypography classes={{ root: classes.titleRoot }}>
            <Typography component="h2" className={classes.title}>
              Download receipt
            </Typography>
            <Typography className={classes.bodyText}>
              Download a PDF receipt for transaction #{transactionId}. The file
              will save to your device automatically.
            </Typography>
          </DialogTitle>
          <DialogActions className={classes.actions}>
            <Button
              onClick={closeDialog}
              color="primary"
              disabled={isDownloading}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<FileDownloadOutlinedIcon />}
              onClick={onDownload}
              disabled={isDownloading}
            >
              {isDownloading ? 'Generating...' : 'Download PDF'}
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

DownloadReceiptDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  isDownloading: PropTypes.bool.isRequired,
  transactionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
}

export default DownloadReceiptDialog
